import http from "./client"

export const runQuery = async (data: { resource_id: string; query: string }): Promise<any> => {
  const res = await http.post(`/editor/queries/run`, data)
  return res.data
}

export const generateQuery = async (data: { resource_id: string; question: string }): Promise<{ query: string }> => {
  const res = await http.post(`/editor/queries/generate-query`, data)
  return res.data
}

export const updateQuery = async (data: {
  resource_id: string
  sql: string
  question: string
  selected_sql?: string
}): Promise<{ query: string }> => {
  const res = await http.post(`/editor/queries/update-query`, data)
  return res.data
}

export interface SavedQueryItem {
  id: string
  name: string
  sql: string
  default_resource_id: string | null
  is_favorite: boolean
}

export const listQueries = async (): Promise<SavedQueryItem[]> => {
  const res = await http.get<SavedQueryItem[]>(`/editor/queries`)
  return res.data
}

export const saveQuery = async (data: {
  name?: string
  sql: string
  default_resource_id?: string
  is_favorite?: boolean
  id?: string
}): Promise<any> => {
  const res = await http.post(`/editor/queries`, data)
  return res.data
}

export const deleteQuery = async (id: string): Promise<void> => {
  await http.delete(`/editor/queries/${id}`)
}
